module.exports = __webpack_public_path__ + "img/leftcard.df2706a2.png";